// extracted by mini-css-extract-plugin
module.exports = {"display-image":"display-image--1CcNY","menu":"menu--3ftNX","image":"image--1Fam3"};